import { Box, Button, Stack, Typography, MenuItem,TextField, Skeleton, Alert, Snackbar } from '@mui/material'
import { useState, useContext } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { ToolContext } from '../../../core/context/ToolContext'
import { SnakeLoader } from '../../../core/loader/SnakeLoader'
import { CircleCheck } from '../../../core/global/Icons';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';
import { NewExam } from './modals/NewExam'
import { Success } from './modals/Success'
export const PlanToTake = () => {
    const { tool_state, home_state } = useContext(ToolContext)
    const [isAlert, setisAlert] = useState(false);
    const planToTake = home_state.planToTake
    const __SESSION = tool_state.__SESSION.data
    const [dialog, setDialog] = useState({open: false, name: null})
    const [exams, setExams] = useState([])
    const [input, setInput] = useState({date: dayjs(moment().format('YYYY-MM-DD')), days: 0, type: null, name: null })
    const [loading, setLoading] = useState({exams: false, save: false})
    const [disable, setDisable] = useState(true)
    const fetchExams = async(value) => {
        setLoading({...loading, exams: true})
        setInput({...input, type: value})
        if(value === 0){
            let fetch = await rqx.get(`<<tool>>/${env()}/certification/all`)
            if(fetch.msg==='success'){
                setExams(fetch.data)
            }
        }else{
            let fetch = await rqx.get(`<<tool>>/${env()}/licensure/read`)
            if(fetch.length >= 1){
                setExams(fetch)
            }
        }
        setLoading({...loading, exams: false})
    }
    const handleExam = async(e) => {
        const {name, value} = e.target
        if(value === ""){
            setDialog({open: true, name: 'new-exam'})
        }else{
            setInput({...input, [name]: value})
            setDisable(false)
        }
    }
    const handleChange = (newValue) => {
        let duration = moment(moment(newValue.$d.toISOString()).format('YYYY-MM-DD')).diff(new Date(),'days');
        setInput({...input, date: newValue, days: duration})
    }
    const handleSubmit = async() => {
        setLoading({...loading, save: true});
        let filter = exams.filter(f => f.name === input.name)
        let fetch = await rqx.post(`<<tool>>/${env()}/myReviewer/createExamType`, {certification_id: input.type === 0 ? filter[0].id : 0, licensure_id: input.type === 1 ? filter[0].id : 0, created_by: parseInt(window.atob(__SESSION.ainfo.aid).split('_')[1])})
        if(fetch.msg === 'success'){
            savePlan(filter[0].id, filter[0].name)
        }
    }
    const savePlan = async(examId, examName) => {
        let params = {aid: parseInt(window.atob(__SESSION.ainfo.aid).split('_')[1]), month: moment(input.date.$d.toISOString()).format('M'), year: moment(input.date.$d.toISOString()).format('YYYY'), day: moment(input.date.$d.toISOString()).format('D'), certification_id: input.type === 0 ? examId : 0, licensure_id: input.type === 1 ? examId : 0, exam_name: examName}
        let savePlan = await rqx.post(`<<tool>>/${env()}/userPlan/createv2`, params)
        if(savePlan.msg === 'success'){
            planToTake.set({...planToTake.data, when: [{id: savePlan.planId, month: moment(input.date.$d.toISOString()).format('M'), year: moment(input.date.$d.toISOString()).format('YYYY'), day: moment(input.date.$d.toISOString()).format('D')}], licensure_id: input.type === 1 ? examId : 0, certification_id: input.type === 0 ? examId : 0, exam_name: examName})
            setDialog({name: 'success', open: true})
        }
    }
    const handleClose = () => {
        setisAlert(false);
    }
    return (
        <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column' height="100%" width="100%">
            <Box>
                <Typography color="#333333" fontSize="24px" fontWeight="bold" py={2}>What exam do you plan to take?</Typography>
                <Box fontSize="14px" mb="5px" mt="10px">Select Type:</Box>
                <Stack direction="row" spacing={2}>
                    <Button sx={{width: '50%', border: '1px solid #E5EBF6', color: (input.type === 0 ? '#fff' : '#313131'), bgcolor: (input.type === 0 ? '#256EFF' : '#fff'), '&:hover': {bgcolor: input.type === 0 ? '#256EFF' : '#fff'}}} onClick={()=>fetchExams(0)}>Certification</Button>
                    <Button sx={{width: '50%', border: '1px solid #E5EBF6', color: (input.type === 1 ? '#fff' : '#313131'), bgcolor: (input.type === 1 ? '#256EFF' : '#fff'), '&:hover': {bgcolor: input.type === 1 ? '#256EFF' : '#fff'}}} onClick={()=>fetchExams(1)}>Licensure</Button>
                </Stack>
                <Box fontSize="14px" mb="5px" mt="10px">Name of Exam:</Box>
                {
                    loading.exams ? (
                        <Skeleton variant="rounded" width={'100%'} height={55} sx={{borderRadius: '8px', mb: 2}} />
                    ) : (
                        <TextField id="outlined-select-currency" select fullWidth value={input.name} name="name" onChange={(e)=>handleExam(e)} disabled={exams.length > 0 ? false : true}>
                            {exams.map((e) => (
                                <MenuItem key={e.id} value={e.name} disabled={e.active !== undefined ? e.active : false}>{(e.active !== undefined && e.active) && <CheckCircleIcon fontSize="small" sx={{color: '#008F5D'}}/>} {e.name} </MenuItem>
                            ))}
                            <MenuItem key="100" value="">Add new {input.type === 0 ? 'certification' : 'licensure'}</MenuItem>
                        </TextField>
                    )
                }
                <Box fontSize="14px" mb="5px" mt="10px">When:</Box>
                <Box sx={{boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.06)'}} borderRadius="6px" p="16px" mb="5px">
                    <Box color="#313131" fontSize="16px" mb="5px" fontWeight={600}>{moment(input.date.$d.toISOString()).format('MMM DD, YYYY')}</Box>
                    <Box color="#0070EF" fontSize="14px">{input.days} days remaining</Box>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar value={input.date} minDate={dayjs(moment().format('YYYY-MM-DD'))} onChange={(e)=>handleChange(e)}/>
                </LocalizationProvider>
                <Box display="flex" justifyContent="flex-end">
                    {
                        loading.save ? (
                            <Box bgcolor="#256EFF" borderRadius="6px" p="6px 10px">
                                <Box height="25px" display="flex" alignItems="center" justifyContent="center"><SnakeLoader size="8px" bg="#fff" distance="0.3rem" /></Box>
                            </Box>
                        ) : (
                            <Button variant="contained" color="primary" sx={{padding: '6px 24px'}} onClick={handleSubmit} disabled={disable}>Save</Button>
                        )
                    }
                </Box>
            </Box>
            {
                dialog.name === 'new-exam' && <NewExam dialog={dialog} exams={exams} input={input} setDialog={setDialog} setExams={setExams} setisAlert={setisAlert} setInput={setInput} __SESSION={__SESSION} setDisable={setDisable}/>
            }
            {
                dialog.name === 'success' && <Success dialog={dialog} setDialog={setDialog} input={input}/>
            }
            <Snackbar open={isAlert} anchorOrigin={{vertical: 'top', horizontal: 'center'}} autoHideDuration={6000} onClose={handleClose}>
                <Alert variant="filled"  severity="success" icon={<CircleCheck fontSize="inherit" fill="#008F5D"/>} sx={{ width: '100%', color: '#008F5D', bgcolor: '#E8F5E9', border: '1px solid #008F5D'}}>
                    New exam successfully saved.
                </Alert>
            </Snackbar>
        </Box>
    )
}